import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
const Index = React.lazy(() => import("pages/index"));
const AdminIndex = React.lazy(() => import("pages/admin"));
const ChatAssistantNoAccess = React.lazy(() => import("pages/components/Others/chatAssistantNoAccess") )

const AppRoutes = () => {
    return (
      <Suspense>
        <Routes>
          <Route path="/chat" element={<Index />} />
          <Route path="/admin" element={<AdminIndex />} />
          <Route path="/noaccess" element={<ChatAssistantNoAccess />} />
          <Route path="/*" element={<Navigate to={'/chat'}/>} />
        </Routes>
      </Suspense>
    );
  }
  export default AppRoutes;